import { ConfigProvider, ThemeConfig } from "antd";

import "./constants/routes";
import Routing from "./routing/routing";

import "./theme/variables.scss";
import "./theme/mixins.scss";
import "./theme/global.scss";

import { ANTD_THEME } from "./theme/antd-theme";

const App = () => {
  return (
    <ConfigProvider
      theme={{
        ...ANTD_THEME,
      }}
    >
      <Routing />
    </ConfigProvider>
  );
};

export default App;
